// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActiveMarketsDropdownController from "./active_markets_dropdown_controller"
application.register("active-markets-dropdown", ActiveMarketsDropdownController)

import AuctionsController from "./auctions_controller"
application.register("auctions", AuctionsController)

import BaseDropdownController from "./base_dropdown_controller"
application.register("base-dropdown", BaseDropdownController)

import ClearAllFiltersController from "./clear_all_filters_controller"
application.register("clear-all-filters", ClearAllFiltersController)

import CleaveController from "./cleave_controller"
application.register("cleave", CleaveController)

import ClickableRowController from "./clickable_row_controller"
application.register("clickable-row", ClickableRowController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import EnableButtonController from "./enable_button_controller"
application.register("enable-button", EnableButtonController)

import ExpandableTextController from "./expandable_text_controller"
application.register("expandable-text", ExpandableTextController)

import FavoritesFilterToggleController from "./favorites_filter_toggle_controller"
application.register("favorites-filter-toggle", FavoritesFilterToggleController)

import GtmEventController from "./gtm_event_controller"
application.register("gtm-event", GtmEventController)

import ImageFallbackController from "./image_fallback_controller"
application.register("image-fallback", ImageFallbackController)

import InputSanitizerController from "./input_sanitizer_controller"
application.register("input-sanitizer", InputSanitizerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MarketCardController from "./market_card_controller"
application.register("market-card", MarketCardController)

import MultiSelectDropdownController from "./multi_select_dropdown_controller"
application.register("multi-select-dropdown", MultiSelectDropdownController)

import OtherFiltersDropdownController from "./other_filters_dropdown_controller"
application.register("other-filters-dropdown", OtherFiltersDropdownController)

import PriceRangeDropdownController from "./price_range_dropdown_controller"
application.register("price-range-dropdown", PriceRangeDropdownController)

import PricingCarouselController from "./pricing_carousel_controller"
application.register("pricing-carousel", PricingCarouselController)

import PriceSliderController from "./price_slider_controller"
application.register("price-slider", PriceSliderController)

import QueryCheckoutStatusController from "./query_checkout_status_controller"
application.register("query-checkout-status", QueryCheckoutStatusController)

import SetCookieController from "./set_cookie_controller"
application.register("set-cookie", SetCookieController)

import ShowMoreController from "./show_more_controller"
application.register("show-more", ShowMoreController)

import SqmRangeDropdownController from "./sqm_range_dropdown_controller"
application.register("sqm-range-dropdown", SqmRangeDropdownController)

import StripeController from "./stripe_controller"
application.register("stripe", StripeController)

import SubmitFormController from "./submit_form_controller"
application.register("submit-form", SubmitFormController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import ValueDifferenceRangeDropdownController from "./value_difference_range_dropdown_controller"
application.register("value-difference-range-dropdown", ValueDifferenceRangeDropdownController)
